export default __webpack_public_path__ + "static/media/diem-den-pho-bien.80cdaffe.png";